/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".col-filtro[_ngcontent-%COMP%]{max-width:200px}  .col-filtro mdb-select .dropdown-content{min-width:300px!important;width:auto!important}.filtro-vendedor[_ngcontent-%COMP%]     mdb-select .dropdown-content{min-width:250px!important}.filtro-familia[_ngcontent-%COMP%]     mdb-select .dropdown-content{min-width:250px!important}"];
export { styles as styles };
